/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuButton, NeuFeedback } from '@neutron/react';

export const StyledDownloadBtn = styled(NeuButton)`
  > button {
    font-size: 1rem;
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }
`;

export const TinySpinner = styled(NeuFeedback)`
  > svg {
    height: 20px !important;
    width: 20px !important;
  }
`;

export const DownloadOptionsContainer = styled.div`
  position: absolute;
  right: 1rem;
  top: 12rem;
  background: white;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 10px;
  z-index: 100;
`;

export const DownloadLoadingSpinner = styled(NeuFeedback)`
  > svg {
    height: 80px !important;
    width: 100px !important;
  }
`;
